import { Injectable, signal } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { BaseEntity } from 'shared/models/BaseEntity';
import {
  AboutRecordAnyDataComponent,
} from '../../shared/components/about-record-any-data/about-record-any-data.component';

@Injectable({
  providedIn: 'root',
})
export class AboutRecordAnyDialogDialogService<T> {
  private readonly activeRecord = signal<T | null>(null);
  private readonly entityLabel = signal<string | undefined>(undefined);


  constructor(private readonly dialog: MatDialog) {
  }

  trackRecord(record: T | null, entityLabel: string | undefined): void {
    this.activeRecord.set(record);
    this.entityLabel.set(entityLabel);

    if (!record) {
      return;
    }
  }

  open(record?: BaseEntity): void {
    const entity = record ?? this.activeRecord();
    if (!entity) {
      return;
    }

    this.dialog.open(AboutRecordAnyDataComponent, {
      width: '800px',
      data: {
        entity,
        entityLabel: this.entityLabel()
      },
      autoFocus: false,
    });
  }
}

